import { render, staticRenderFns } from "./defineColumn.vue?vue&type=template&id=25c454c3&"
import script from "./defineColumn.vue?vue&type=script&lang=js&"
export * from "./defineColumn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports